import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 10px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;

  > button {
    width: 100%;
    height: 48px;
    background: #2b8ff5;
    border-radius: 8px;
    border: none;
    color: #fff;
    font-weight: 500;
    font-size: 14px;
  }
`;

export const DivDeliveryPlace = styled.div`
  display: flex;
  flex-direction: column;

  > strong {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #000000;
  }

  > span {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    color: #838383;
    margin-bottom: 12px;
  }

  > button {
    width: 100%;
    height: 50px;
    border: none;
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    background: #2b8ff5;
    border-radius: 8px;
    margin-bottom: 8px;
  }
`;

export const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0.5px solid #d8dee5;
  border-radius: 8px;
  height: 62px;
  width: 100%;
  padding: 0 16px;
  background: ${props => props.background || 'none'};
  margin-top: 8px;

  .left {
    display: flex;
    position: relative;
    width: 100%;
    flex-direction: column;

    span {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      display: flex;
      align-items: center;
      color: #000000;
    }

    .price {
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      color: #9d9d9d;
    }

    > div {
      display: flex;
      align-items: center;
    }
  }

  .right {
    display: flex;

    > button {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 19px;
      color: #2b8ff5;
      border: none;
      background: none;
    }
  }

  input:checked + .slider {
    background-color: ${props => props.switchColorActive || '#2B8FF5'};
  }
`;

export const DivDeliveryName = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 32px 0 0 0;

  > strong {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #000000;
  }

  > span {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    color: #838383;
    margin-bottom: 12px;
  }

  > input {
    width: 100%;
    height: 50px;
    background: #f9f9f9;
    border-radius: 8px;
    border: none;
    padding: 0 12px;

    &::placeholder {
      font-size: 13px;
      color: #bfbfbf;
    }
  }
`;

export const DivValidLocales = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;

  > strong {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #000000;
  }

  > span {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    color: #838383;
    margin-bottom: 12px;
  }
`;

export const DivSelectedCities = styled.div`
  display: flex;
  margin-top: 16px;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #efefef;
    border-radius: 8px;
    height: 42px;
    padding: 0 12px;
    font-size: 13px;
    color: #000000;

    > div {
      margin-left: 12px;
      cursor: pointer;
    }

    & + div {
      margin-left: 8px;
    }
  }
`;

export const DivInputCities = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > div {
    display: flex;
    width: 100%;
    cursor: pointer;

    & + div {
      margin-top: 8px;
    }

    > input {
      background: #f9f9f9;
      border-radius: 8px;
      border: none;
      padding: 12px;
      font-size: 13px;
      color: #000000;
      width: 100%;

      & + input {
        margin-top: 8px;
      }
    }

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      margin-left: 8px;
    }
  }

  > button {
    font-weight: 500;
    font-size: 13px;
    color: #2b8ff5;
    border: none;
    background: none;
    margin-top: 12px;
  }
`;

export const DivMethod = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  > span {
    margin-bottom: 16px;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: #000000;
  }
`;

export const Radio = styled.div`
  display: flex;

  & + div {
    margin-top: 12px;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background: #efefef;
    border-radius: 50%;
    margin-right: 10px;

    > div {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #efefef;
    }
  }

  .selected {
    background: #2b8ff5;

    > div {
      background: #fff;
    }
  }
`;

export const AddPlace = styled.div`
  display: flex;
`;

export const SeeMore = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #2b8ff5;
  margin: auto;
  cursor: pointer;
  margin-top: 20px;
`;

export const DivBackground = styled.div`
  position: fixed;
  height: 100vh;
  width: 100%;
  background: rgba(227, 229, 236, 0.65);
  z-index: 10;
  top: 0;
  left: 0;
  z-index: 501;
`;

export const DivAddPlace = styled.div`
  display: flex;
  position: fixed;
  flex-direction: column;
  /* top: auto; */
  /* bottom: 0; */
  top: calc(50vh - (500px / 2));
  left: calc(50vw - (600px / 2));
  width: 100%;
  max-width: 600px;
  background: #fff;
  border-radius: 20px;
  z-index: 502;
  height: 500px;

  .header {
    min-height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;

    > strong {
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      text-align: center;
      color: #000000;
    }

    > button {
      position: absolute;
      right: 24px;
      cursor: pointer;
      background: none;
      border: none;
      font-weight: 500;
      font-size: 13px;
      line-height: 19px;
      color: #ff303c;
    }

    > img {
      position: absolute;
      right: 24px;
      cursor: pointer;
    }
  }

  .required {
    font-size: 13px;
    line-height: 18px;
    color: #2b8ff5;
    margin-left: 6px;
  }

  .body {
    display: flex;
    flex-direction: column;
    padding: 0 16px 106px 16px;
    overflow-y: scroll;

    /* height: 450px; */

    > button {
      display: flex;
      align-self: flex-start;
      font-weight: 500;
      font-size: 13px;
      line-height: 19px;
      color: #2b8ff5;
      border: none;
      background: none;
      margin-bottom: 16px;
    }

    > input {
      background: #f9f9f9;
      border-radius: 8px;
      min-height: 42px;
      border: none;
      padding: 0 12px;
      margin-bottom: 24px;

      &::placeholder {
        color: #bfbfbf;
      }
    }
  }

  > footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 16px;
    border-top: 0.5px solid #d8dee5;
    background: #fff;
    border-radius: ${props => (props.isDesktop ? '0 0 20px 20px' : '0')};
    border-radius: 0 0 20px 20px;

    > button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      background: #2b8ff5;
      border-radius: 8px;
      height: 50px;
      border: none;
      color: #fff;
    }
  }
`;

export const Div = styled.div`
  margin-bottom: 4px;
  margin-top: ${props => props.marginTop || '0'};

  > div {
    display: flex;

    > strong {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 19px;
      color: #000000;
    }

    > span {
      font-size: 13px;
      line-height: 18px;
      color: #9d9d9d;
      margin-left: 6px;
    }
  }

  > span {
    font-size: 13px;
    color: #838383;
  }
`;

export const DivPrice = styled.div`
  display: flex;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 45px;
    background: #efefef;
    border-radius: 8px 0px 0px 8px;
    font-size: 13px;
    color: #101010;
  }

  input {
    background: #f9f9f9;
    border-radius: 0px 8px 8px 0px;
    border: none;
    width: 100px;
    padding: 0 12px;

    &::placeholder {
      font-size: 13px;
      color: #bfbfbf;
    }
  }
`;

export const DivDatePeriod = styled.div`
  display: flex;
  align-items: center;

  > input {
    width: 80px;
    height: 42px;
    background: #f9f9f9;
    border-radius: 8px;
    border: none;
    text-align: center;
    margin: 0 8px;
  }
`;
